import { FlashMessageDto } from '../../../dto/flashmessage/get/flashmessagedto';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface GetPredefinedFlashMessageResponse extends MiddlewareAPIResponse
{
    getFlashMessageResponseDtos(): FlashMessageDto[];
}

export class GetPredefinedFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements GetPredefinedFlashMessageResponse
{
    private getFlashMessageDto : FlashMessageDto[];

    getFlashMessageResponseDtos(): FlashMessageDto[]
    {
        return this.getFlashMessageDto;
    }

    setFlashMessageResponseDtos(getFlashMessageDto: FlashMessageDto[])
    {
        this.getFlashMessageDto = getFlashMessageDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesresponse.tsx